import getApi from '../../api'

export const deletePatientInformations = (patientId: string, patientInformationsId: string) =>
  getApi().delete<void>(`patients/${patientId}/patient_informations/${patientInformationsId}`)
